import { useSelector } from 'react-redux'
import { isSsmlValidationEnabledSelector } from '../selectors'

export function useIsSsmlValidationEnabled(): boolean {
  return useSelector(isSsmlValidationEnabledSelector)
}
